<template>
  <header class="main-header " :class="{'main-header-home': $route.path=='/'}">
    <!-- <topHeader/> -->
    <section
      class="
      down-header
       
        w-100
        d-flex
        justify-content-lg-between
        align-items-baseline
        py-3
       
      " :class="{ 'fixed-header': activeFixedHEader, ' container': !activeFixedHEader }" id="down-header">
      <!-- top-header-position -->

      <div class=" w-100
    d-flex
    justify-content-between
    align-items-baseline" :class="{ 'container': activeFixedHEader }">





        <button type="button" id="all-categories" class="
          all-categories
          resp-menu-btn
          px-1
          d-lg-none
        " @click="allCategoriesClose()">
          <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1" id="Capa_1" viewBox="0 0 283.426 283.426" xml:space="preserve">
            <g>
              <rect x="0" y="40.84" style="fill:#010002;" width="283.426" height="47.735" />
              <rect x="0" y="117.282" style="fill:#010002;" width="283.426" height="47.735" />
              <rect x="0" y="194.851" style="fill:#010002;" width="283.426" height="47.735" />
            </g>
          </svg>
        </button>

        <div class="d-flex align-items-center gap-16">
          <AtlasLogo />
          <Nav></Nav>
        </div>
        <div class=" d-flex align-items-center" style="gap:8px;">


          <!-- <SearchButton class="d-md-inline-block d-none bg-none ml-2"/> -->

          <!-- اگر لاگین نبود ایکن ورود نمایش داده شود -->
          <searchHeader class="search-header cursor-pointer" />
          <button v-if="!isLogin" type="button" class="d-md-inline-block d-none  login" data-toggle="modal"
            data-target="#loginModal">
            <!-- <svg
            width="27"
            height="27"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="11.5789"
              cy="7.27803"
              r="4.77803"
              stroke="#444"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.00002 18.7014C3.99873 18.3655 4.07385 18.0337 4.2197 17.7311C4.67736 16.8158 5.96798 16.3307 7.03892 16.111C7.81128 15.9462 8.59431 15.836 9.38217 15.7815C10.8408 15.6533 12.3079 15.6533 13.7666 15.7815C14.5544 15.8367 15.3374 15.9468 16.1099 16.111C17.1808 16.3307 18.4714 16.77 18.9291 17.7311C19.2224 18.3479 19.2224 19.064 18.9291 19.6808C18.4714 20.6419 17.1808 21.0812 16.1099 21.2918C15.3384 21.4634 14.5551 21.5766 13.7666 21.6304C12.5794 21.7311 11.3866 21.7494 10.1968 21.6854C9.92221 21.6854 9.65677 21.6854 9.38217 21.6304C8.59663 21.5773 7.81632 21.4641 7.04807 21.2918C5.96798 21.0812 4.68652 20.6419 4.2197 19.6808C4.0746 19.3747 3.99955 19.0401 4.00002 18.7014Z"
              stroke="#444"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg> -->
            <!-- ورود / عضویت -->
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="black" viewBox="0 0 256 256">
              <path
                d="M230.92,212c-15.23-26.33-38.7-45.21-66.09-54.16a72,72,0,1,0-73.66,0C63.78,166.78,40.31,185.66,25.08,212a8,8,0,1,0,13.85,8c18.84-32.56,52.14-52,89.07-52s70.23,19.44,89.07,52a8,8,0,1,0,13.85-8ZM72,96a56,56,0,1,1,56,56A56.06,56.06,0,0,1,72,96Z">
              </path>
            </svg>
          </button>


          <!-- <div class="d-inline-block" :class="notifications?.items?.length ? 'ml-4' : 'ml-1'"> -->
          <div class="d-flex">
            <!-- :class="
            notifications && notifications.items && notifications.items.length
              ? 'ml-4'
              : 'ml-1'
          " -->
            <button @click="GoToFavorite()" class="btn-Favorite ml-2 d-md-inline-block d-none">

              <Favorite />
            </button>
            <CartButton  />
            <!-- <HeaderNotification v-if="notifications" v-show="notifications && notifications.items && notifications.items.length
        " :value="notifications" /> -->
            <!-- لاگین بود نمایش حساب کاربری -->
          </div>
          <template v-if="isLogin">
            <LoginUser :atlasTheme="false" />
          </template>
        </div>
      </div>

      <!-- <SearchButton class="bg-none ml-2 d-md-none"/> -->
    </section>
    <MainSearch></MainSearch>
    <!-- resp login Modal -->
    <RespLoginModal></RespLoginModal>
    <CartLists></CartLists>
    <!-- <TopSliderHome v-if="$route.path == '/'  "/> -->

    <!-- <section class="d-flex justify-content-center container-md px-0">
      <ProductCategories></ProductCategories>
    </section> -->



    <RespMenu ref="respMenu"></RespMenu>
    <!--    <div class="all-categories-resp" @click="allCategoriesCloseBody()"></div> &lt;!&ndash; close menu by click to body&ndash;&gt;-->
  </header>
</template>

<script>
import TopSliderHome from "./TopSliderHome.vue";
// import TopSliderHome2 from "./TopSliderHome2.vue";
import searchHeader from "../../components/searchBox/searchHeader.vue";
import topHeader from "./topHeader.vue";
import Favorite from "../icons/Favorite.vue";
import AtlasLogo from "@/parts/Front/components/AtlasLogo";
import Swiper from "swiper/swiper-bundle.min.js";
import Nav from "@/parts/Front/components/Nav";
import ProductCategories from "@/parts/Front/components/ProductCategories";
import RespMenu from "@/parts/Front/components/RespMenu";
import MainSearch from "@/parts/Front/components/MainSearch";
import LoginUser from "@/parts/Front/components/LoginUser";
import RespLoginModal from "@/parts/Front/components/RespLoginModal";
import CartLists from "@/parts/Front/components/CartLists";
import findUrl from "@/libraries/links/LinkResolver";
import HeaderNotification from "@/parts/Front/components/notification/HeaderNotification";
import CartButton from "@/parts/Front/components/cart/CartButton";
import DynamicLinker from "./DynamicLinker";
// import SearchButton from "../header/SearchButton";
import { BSkeletonImg } from "bootstrap-vue";

export default {
  name: "Header",
  components: {
    // SearchButton,
    TopSliderHome,
    searchHeader,
    DynamicLinker,
    AtlasLogo,
    HeaderNotification,
    Nav,
    LoginUser,
    ProductCategories,
    RespMenu,
    MainSearch,
    RespLoginModal,
    CartLists,
    CartButton,
    BSkeletonImg,
    Favorite,
    topHeader,
    // TopSliderHome2
  },
  watch: {
    sliderData() {
      // پاک کردن سویپر برای نمایش درست اسلایدر
      // this.initHeaderSwiper(true);
    },
  },
  inject: ["mediaQueries"],
  methods: {
    GoToFavorite() {
      if (!this.isLogin) {
        this.alertLogin()
      } else {
        this.$router.push("/user-panel?section=favorites")
      }
    },
    alertLogin() {
      this.$root.notify(
        "برای رفتن به صفحه علاقه مند های خود لطفا ابتدا وارد سایت شوید."
        , 'warning');
    },
    showHeader(e) {
      if (scrollY >= 100) {
        this.activeFixedHEader = true
      } else {
        this.activeFixedHEader = false

      }

    },
    getSlidersFromServer() {
      this.$store.dispatch('front/getSlidersFromServer');
    },
    findUrl,
    getSliderCustomFields(slider) {
      return JSON.parse(slider.custom_fields);
    },
    allCategoriesClose() {
      this.$refs.respMenu.allCategoriesToggle();
    },
    onResize() {
      let topSliderH = document.querySelector(".top-slider");
      let bodyWidth = document.body.offsetWidth;
      if (topSliderH) {
        if (bodyWidth < 767) {
          // topSliderH.style.height = bodyWidth / 1.6 + "px";
        } else {
          // topSliderH.style.height = bodyWidth / 2.2 + "px";
        }
      }
    },
    // initHeaderSwiper(kill = false) {
    //   this.initSwiper("header-swiper", kill, () => {
    //     new Swiper(".top-slider .swiper-container", {
    //       spaceBetween: 0,
    //       //   centeredSlides: true,
    //       speed: 1000,
    //       loop: true,
    //       autoplay: {
    //         delay: 4500,
    //         disableOnInteraction: false,
    //       },
    //       pagination: {
    //         el: ".top-slider .swiper-pagination",
    //         clickable: true,
    //       },
    //       navigation: {
    //         nextEl: ".top-slider .swiper-button-next",
    //         prevEl: ".top-slider .swiper-button-prev",
    //       },
    //     });
    //   });
    //   this.$nextTick(() => {
    //     this.onResize();
    //   });
    // },
    signout() {
      window
        .swal({
          title: "آیا میخواهید خارج شوید؟",

          icon: "warning",

          showCancelButton: true,
          showConfirmButton: true,
          dangerMode: true,
          buttons: ["خیر", "بله خارج شو"],
        })
        .then((willDelete) => {
          if (willDelete) {
            this.disabledlLogout = true;
            this.$axios.post("/customer/logout").then((res) => {
              this.disabledlLogout = false;
              this.showOptions = false;
              // پاک کردن اطلاعات مربوط به کاربر از کوکی و ویو ایکس
              delete this.$axios.defaults.headers.common["Authorization"];
              this.$root.deleteCookie("Authorization");
              this.$store.commit("front/setLoginStatus", false);

            });
          }
        });
    },
  },
  mounted() {
    // ست کردن تنظیمات  برای اسکرول صفحه در برابر رسپانسیو
    window.removeEventListener("resize", this.onResize);
    window.addEventListener("resize", this.onResize);
    window.addEventListener("scroll", this.showHeader);
    if (!this.sliderData) {
      this.getSlidersFromServer();
    }
    //CHange height of top-slider
    const topSliderH = document.querySelector(".top-slider");
    const bodyWidth = document.body.offsetWidth;
    if (topSliderH) {
      if (bodyWidth < 767) {
        topSliderH.style.height = bodyWidth / 1.6 + "px";
      } else {
        topSliderH.style.height = bodyWidth / 2.2 + "px";
      }
    }

    window.removeEventListener("resize", this.onResize);
    window.addEventListener("resize", this.onResize);
    window.addEventListener("scroll", this.showHeader);
  },
  computed: {
    // دریافت دیتا از سمت ویوایکس
    sliderData() {
      return this.$store.getters["front/getSliders"];
    },
    sliders() {
      let sliders;

      if (this.mediaQueries.medium) {
        sliders = this.sliderData.sliders.filter((s) =>
          s.group.includes("mobile")
        );
      } else {
        sliders = this.sliderData.sliders.filter(
          (s) => !s.group.includes("mobile")
        );
      }
      sliders.forEach((slider) => {
        try {
          slider.custom_fields = this.getSliderCustomFields(slider);
        } catch (e) { }
      });

      return sliders;
    },
    // چک کردن لاگین بودن کاربر با استفاده از ویو ایکس در سند یوزر
    isLogin() {
      return this.$store.getters["front/getLoginStatus"];
    },
    // دریافت اطلاعات کاربر
    FullName() {
      return this.$store.getters["front/getFullName"];
    },
    status() {
      return this.$store.getters["front/getHomeDataStatus"];
    },
    notifications() {
      return this.$store.getters["front/getNotifications"];
    },
  },

  data() {
    return {
      disabledlLogout: false,
      activeFixedHEader: false,
    };
  },
};
</script>

<style scoped>
/*.main-header.main-header-home{
  background-color: #fff;

}*/
.main-header{
  background-color: var(--pink-theme1);
  

}
.all-categories{
  background-color: unset;
}

.btn-Favorite {
  background-color: unset;
}

.fixed-header {
  position: fixed;
  top: -100px;
  z-index: 100;
  background: var(--pink-theme1);
  left: 0;

  max-width: 100vw !important;

  animation: moveHeader .8s linear forwards;
}

@keyframes moveHeader {
  0% {
    top: -100px;


  }

  100% {
    top: 0px;

  }
}

.search-header {
  margin-left: 4px;
  /*padding-left: 12px;
  border-left: 1px solid var(--gray-e9);*/
}

.top-slider {
  height: 550px !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.75s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.login {
  background-color: unset;
}

@media screen and (max-width:639px) {
  .top-slider {
    height: 250px !important;
  }

}
</style>
